import { Controller } from "@hotwired/stimulus";

const URL_PATTERN = /^https?:\/\//i;

// Validates a URL field on blur and blocks the sibling autosave controller from
// saving until the value is fixed. Usage: data-controller="url-validator" on a
// wrapper element inside an autosave form, data-url-validator-target="field" on
// the input, data-url-validator-target="error" on the message element, and
// data-url-validator-invalid-msg-value for the i18n error text.
export default class extends Controller {
  static targets = ["field", "error"];
  static values = { invalidMsg: String };

  validate() {
    const value = this.fieldTarget.value.trim();
    if (value === "" || URL_PATTERN.test(value)) {
      this._clearError();
    } else {
      this._showError();
    }
  }

  clear() {
    this._clearError();
  }

  _showError() {
    this.fieldTarget.classList.add("input-error");
    this.errorTarget.textContent = this.invalidMsgValue;
    this.errorTarget.hidden = false;
    this._autosave?.block();
  }

  _clearError() {
    this.fieldTarget.classList.remove("input-error");
    this.errorTarget.textContent = "";
    this.errorTarget.hidden = true;
    this._autosave?.unblock();
  }

  get _autosave() {
    const form = this.element.closest("form");
    return form && this.application.getControllerForElementAndIdentifier(form, "autosave");
  }
}
